import { gql } from '@apollo/client/core';

export const CREATE_JOB_RECRUIT = gql`
  mutation CreateJobRecruit($jobId: UUID!, $providerId: UUID!) {
    createJobRecruit(jobId: $jobId, providerId: $providerId) {
      jobId
    }
  }
`;
